export default "__VITE_ASSET__4f376afb__"